var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 6.5918L28.1758 29.0064L15.481 31.4997L2.82124 29.0098L0 6.5918H31Z",
    fill: "#F16529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 29.5949L25.758 27.5801L28.1713 8.42578H15.5V29.5949Z",
    fill: "#F16529",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0103 13.9243H15.5004V11.1748H5.76904L5.86188 11.9124L6.81578 19.4893H15.5004V16.7398H10.365L10.0103 13.9243Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8841 20.8643H6.98828L7.53194 25.1814L15.4817 26.7448L15.4995 26.7413V23.8807L15.4825 23.8839L11.1604 23.0571L10.8841 20.8643Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88428 0.5H4.85649V1.88046H6.66064V0.5H8.63297V4.68039H6.66076V3.28056H4.85661V4.68039H2.8844V0.5H2.88428Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2262 1.88632H9.49023V0.5H14.9359V1.88632H13.1988V4.68039H11.2266V1.88632H11.2265H11.2262Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8003 0.5H17.8567L19.1217 1.96888L20.3855 0.5H22.4427V4.68039H20.4785V2.60836L19.1217 4.09472H19.0877L17.73 2.60836V4.68039H15.8003V0.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.424 0.5H25.3968V3.29864H28.1703V4.68039H23.4238V0.5H23.424Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4869 19.4897H20.2658L19.8152 23.0556L15.4868 23.8833V26.7437L23.4428 25.1816L23.5012 24.7171L24.4133 17.4785L24.5079 16.7402H15.4869V19.4897Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4868 13.9176V13.9243H24.8609L24.9387 13.3063L25.1156 11.9124L25.2084 11.1748H15.4868V13.9177V13.9176Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.30e0f02c79d9fd39bf83fbbc291e6a76.svg";
export { ForwardRef as ReactComponent };